import GoogleAnalytics from './GoogleAnalytics';
import sitiosId from '../Models/SitiosId';
import LoginTypes from '../Models/LoginTypes';
import { User } from '@auth0/auth0-react';
import ModosUrl from '../Models/ModosUrl';

/**
 * Se almacena en el data layer el método de autenticación del usuario y sus datos asociados.
 * @param { User | undefined } user Datos del usuario autenticado
 * @param { Number } sitioId Valor único que identifica el sitio del que fue redireccionado el usuario
 * @param { String } modo Modo de ingreso al sitio (default, signwall, paywall, black, oneTap)
 */
const trackUserHandler = (user, sitioId, modo) => {
  if (user) {
      const origenParsed = Object.keys(sitiosId).find(key => sitiosId[key] === sitioId);
      
      const data = {
          event: !!user.is_registration ? "trackRegister" : "trackLogin",
          loginMethod: getLoginMethod(user.connection_type, modo),
          userId: user.ln_user_id,
          originId: sitioId,
          origenParsed: origenParsed
      }
      GoogleAnalytics.trackUser(data);
  }
};

const getLoginMethod = (connectionType, modo) => {
    const loginMethod = LoginTypes[connectionType];

    if (modo === ModosUrl.googleOneTap && loginMethod === LoginTypes['google-oauth2']) {
        return 'Google One Tap';
    }

    return loginMethod;
}

export {
    trackUserHandler
}